module.exports = __webpack_public_path__ + "fd18f6ab51bddc14ca88877d6a5b6809.svg";